/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  
/* ====== React ====== */
import { useState } from "react"
/* ====== CSS ====== */
import styled from "styled-components"
/* ====== Component Js/Jsx ====== */
import { CFArrayFount, CFDateEdit, CFStingMasterEdit, CFUTCToDateTimeLabelFormatEdit } from "03CommonApiParts/CommonFunction"
import { assets } from "03CommonApiParts/Configuration"
import { CODEDIFINITION_STORAGE } from "03CommonApiParts/CodeDefinition"

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */ 
const SdivApply = styled.div`
	border-bottom: 1px solid #D9D9D9;
	border-left: 1px solid #D9D9D9;
	border-right: 1px solid #D9D9D9;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0px 5px;
	:hover{
		background-color: ${assets().color.backgroundBlue};
		cursor: pointer;
	}
`
const SdivApplySelected = styled.div`
	display: flex;
	align-items: center;
	padding: 0px 5px;
	position: relative;
`
const SdivApplyListWappaer = styled.div`
	width: 780px;
	border: 1px solid #D9D9D9;
`
const SdivApplyList = styled.div`
	max-height:200px;
`
const SdivHistoryListWrapper = styled.div`
	position: relative;
	width: inherit;
`
const SdivHistoryListInner = styled.div`
	position: absolute;
	top: 1px;
	background-color: white;
	z-index: 40;
	width: -webkit-fill-available;
	max-height:200px;
	overflow: auto;
	border-bottom:1px solid #D9D9D9;
`
const SdivApplyHeader = styled.div`
	border: 1px solid #D9D9D9;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0px 5px;
	background-color: ${assets().color.blue};
	color: white;
	font-weight: bold;
`
const SdivNowApply = styled.div`
	width: 120px;
	text-align:right;
`
const SdivApplyDate = styled.div`
	width: 150px;
`
const SdivUpdateDate = styled.div`
	width: 180px;
`
const SdivUpdatePerson = styled.div`
	width: 150px;
	text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    word-break:break-word;
`
const SdivCategory = styled.div`
	width: 250px;
`
/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */ 

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 履歴テーブル ========= */
export const HistryTable = (props) => {
	const { data,onChangeHistory } = props;
	// const {historyList, nowApplied} = props;
	/* ====== sessionStorageからの情報を定義 ====== */ 
	/* CODEDIFINITION_STORAGEからコード定義を取得 */
	const codeDefinitionStorage = sessionStorage.getItem(CODEDIFINITION_STORAGE);//sessionStorageからコードマスタを取得
	var codeDefinitionValue = JSON.parse(codeDefinitionStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
	const historyCategoryCode = CFArrayFount(codeDefinitionValue,'code','historyCategoryCode');

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */
	const [nowSelected, setNowSelected] = useState(data[0]);
	const [openList, setOpenList] = useState(false)
	const onClickPullDown = () =>{
		setOpenList(!openList);
	}
	const onClickTable = (apply) =>{
		setNowSelected(apply); 
		setOpenList(false);
		onChangeHistory(apply);
	};
    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */
	return(
		<SdivApplyListWappaer>
			<SdivApplyHeader>
				<SdivCategory
					style={{fontSize: assets().size.baseText,}}
					className='baseText'
				>
					種類
				</SdivCategory>
				<SdivUpdateDate
					style={{fontSize: assets().size.baseText,}}
					className='baseText'
				>
					更新日時
				</SdivUpdateDate>
				<SdivUpdatePerson
					style={{fontSize: assets().size.baseText,}}
					className='baseText'
				>
					更新者
				</SdivUpdatePerson>
				<SdivApplyDate
					style={{fontSize: assets().size.baseText,}}
					className='baseText'
				>
					適用開始日
				</SdivApplyDate>
				<SdivNowApply>
					
				</SdivNowApply>
			</SdivApplyHeader>
			<SdivApplyList>
					<SdivApplySelected>
						<SdivCategory
							style={{fontSize: assets().size.baseText,}}
							className='baseText'
						>
							{CFStingMasterEdit(historyCategoryCode,nowSelected.histTrgCd)}
						</SdivCategory>
						<SdivUpdateDate
							style={{fontSize: assets().size.baseText,}}
							className='baseText'
						>
							{CFUTCToDateTimeLabelFormatEdit(nowSelected?.upDate)}
						</SdivUpdateDate>
						<SdivUpdatePerson
							style={{fontSize: assets().size.baseText,}}
							className='baseText'
						>
							{nowSelected?.udrFullName}
						</SdivUpdatePerson>
						<SdivApplyDate
							style={{fontSize: assets().size.baseText,}}
							className='baseText'
						>
							{CFDateEdit(nowSelected?.aplySrtDate)}
						</SdivApplyDate>
						<SdivNowApply
							style={{fontSize: assets().size.baseText,}}
							className='baseText'
							onClick={() => onClickPullDown()}
						>
							{nowSelected?.aplyFlag? '適用中': ''}
							{openList ? '　▲':'　▼'}
						</SdivNowApply>
					</SdivApplySelected>
					
					{openList &&
					<SdivHistoryListWrapper>
						<SdivHistoryListInner>
							{data?.filter(hist => hist.id !== nowSelected.id).map((apply) => (
								<SdivApply onClick={()=>onClickTable(apply)}>
									<SdivCategory
										style={{fontSize: assets().size.baseText,}}
										className='baseText'
									>
										{CFStingMasterEdit(historyCategoryCode,apply.histTrgCd)}
									</SdivCategory>
									<SdivUpdateDate
										style={{fontSize: assets().size.baseText,}}
										className='baseText'
									>
										{CFUTCToDateTimeLabelFormatEdit(apply.upDate)}
									</SdivUpdateDate>
									<SdivUpdatePerson
										style={{fontSize: assets().size.baseText,}}
										className='baseText'
									>
										{apply.udrFullName}
									</SdivUpdatePerson>
									<SdivApplyDate
										style={{fontSize: assets().size.baseText,}}
										className='baseText'
									>
										{CFDateEdit(apply.aplySrtDate)}
									</SdivApplyDate>
									<SdivNowApply
										style={{fontSize: assets().size.baseText,}}
										className='baseText'
									>
										{apply.applyFlag? '適用中': ''}
									</SdivNowApply>
								</SdivApply>
							))}
						</SdivHistoryListInner>
					</SdivHistoryListWrapper>
					}
					
			</SdivApplyList>
		</SdivApplyListWappaer>
	)
}